import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { LocalStorage } from '../enums/local-storage';

interface Settings {
  isTaskDrawerPinned: boolean;
  isTaskDrawerOpen: boolean;
  selectedDepartment: string;
}

export const initialValue: Settings = {
  isTaskDrawerPinned: false,
  isTaskDrawerOpen: false,
  selectedDepartment: '',
};

export const SettingsStore = signalStore(
  { providedIn: 'root' },
  withState(initialValue),
  withMethods(({ ...store }) => ({
    openTaskDrawer(isOpen: boolean) {
      patchState(store, {
        isTaskDrawerOpen: isOpen,
        isTaskDrawerPinned: store.isTaskDrawerPinned(),
        selectedDepartment: store.selectedDepartment(),
      });
      sessionStorage.setItem(
        LocalStorage.SETTINGS,
        JSON.stringify({
          isTaskDrawerOpen: isOpen,
          isTaskDrawerPinned: store.isTaskDrawerPinned(),
          selectedDepartment: store.selectedDepartment(),
        }),
      );
    },
    setSelectedDepartment(department: string) {
      patchState(store, {
        selectedDepartment: department,
        isTaskDrawerPinned: store.isTaskDrawerPinned(),
        isTaskDrawerOpen: store.isTaskDrawerOpen(),
      });
      sessionStorage.setItem(
        LocalStorage.SETTINGS,
        JSON.stringify({
          selectedDepartment: department,
          isTaskDrawerPinned: store.isTaskDrawerPinned(),
          isTaskDrawerOpen: store.isTaskDrawerOpen(),
        }),
      );
    },
    pinUnpinTaskDrawer() {
      patchState(store, {
        isTaskDrawerPinned: !store.isTaskDrawerPinned(),
        isTaskDrawerOpen: store.isTaskDrawerOpen(),
        selectedDepartment: store.selectedDepartment(),
      });
      sessionStorage.setItem(
        LocalStorage.SETTINGS,
        JSON.stringify({
          isTaskDrawerPinned: store.isTaskDrawerPinned(),
          isTaskDrawerOpen: store.isTaskDrawerOpen(),
          selectedDepartment: store.selectedDepartment(),
        }),
      );
    },
    reset() {
      patchState(store, initialValue);
    },
  })),
  withHooks({
    onInit({ ...store }) {
      const settingsStr = sessionStorage.getItem(LocalStorage.SETTINGS);
      if (settingsStr) {
        try {
          const settings: Partial<Settings> = JSON.parse(settingsStr);
          patchState(store, {
            isTaskDrawerPinned:
              settings.isTaskDrawerPinned ?? initialValue.isTaskDrawerPinned,
            isTaskDrawerOpen:
              settings.isTaskDrawerOpen ?? initialValue.isTaskDrawerOpen,
            selectedDepartment:
              settings.selectedDepartment ?? initialValue.selectedDepartment,
          });
        } catch (error) {
          patchState(store, initialValue);
        }
      }
    },
    onDestroy() {
      sessionStorage.removeItem(LocalStorage.SETTINGS);
    },
  }),
);
